export const APP_ICONS = {
  ORGANIZATIONAL_HIERARCHY: 'Organizational hierarchy',
  BUDGET_SUMMARY: 'Budget summary',
  MANAGE_USERS: 'Manage users',
  USER_ACTIVITY: 'User activity',
  MANAGE_USER_ACCESS: 'Manage user access',
  COST_ALLOCATION: 'Cost allocation',
  DEPARTMENT_SCORING: 'Department scoring',
  DEPARTMENT_REVIEW: 'Department review',
  PEER_REVIEW: 'Peer review',
  CONFIGURE_SCORING: 'Configure scoring',
  FINAL_REVIEW: 'Final review',
  PROGRAM_INSIGHTS: 'Program insights',
  CONFIGURE_INSIGHTS: 'Configure insights',
  REPORTS: 'Reports',
  BUDGET_REQUESTS: 'Budget requests',
  CONFIGURE_REQUESTS: 'Configure requests',
  SET_UP_BUDGETER: 'Set up budgeter',
  NAME_CONVENTIONS: 'Name conventions',
  CONFIGURE_BUDGET: 'Configure budget',
  MANAGE_ADMIN_USERS: 'Manage admin users',
  DATA_VISUALIZATION: 'Data visualization',
  ORGANIZATION_EDITOR: 'Organization editor',
  PROGRAM_INVENTORY: 'Program inventory',
  MANAGE_ORGANIZATION_ACCESS: 'Manage organization access',
  BUDGET_LINE_ITEM_EDITOR: 'Budget line item editor',
  MANAGE_DATA: 'Manage data',
  PBB_STRATEGIST: 'PBB Strategist',
  COST_BENCHMARK: 'Cost benchmark',
  AI_ANALYTICS: 'AI analytics'
};
